import React from 'react';
import Wrapper from '../../../../../Hoc/Wrapper.js';
import timer from './img/timerIcon.png'

let Plate = (props) => {   
    let shortenTitle = (title) => {
        if(title){
            // title="Rich & Creamy Tomato Basil Soup with Asiago Cheese"; //50 chars 
            let wordList = title.split("");
            if(wordList.length > 50){
                title = title.slice(0, 50) + "...";
            }
            return title;
        }
    }
    let displayPlate = () => {
        let plate = '';
        if(props.title != 'none'){
            plate = (
                <Wrapper>
                    <img className="Plate_Img" src={props.img !== 'useDefaultMeal' ? props.img : 'http://res.cloudinary.com/dyfitjkxt/image/upload/v1530913143/vg68rfh5ll0dehayqh43.png'} alt={props.title}/>
                    <h3 className="Plate_Title">{shortenTitle(props.title)}</h3>
                    <div className="Plate_Info">
                        <img className="Timer_Img"src={timer} alt="timer"/>&nbsp;&nbsp;&nbsp;{props.prepTime}
                    </div>
                </Wrapper>
            );

        } else{
            plate = ( 
            <Wrapper>
                <span className="nothing" />
            </Wrapper>
            );
        }        
        return plate;
    } 
    return (
        <div className={props.title + " Plate_Container"}>
           {displayPlate()}
        </div>
    );
       
}

export default Plate;


// WEBPACK FOOTER //
// ./src/Containers/LandingPage/Components/PlateSection/Plate/Plate.js